
const digest = '29621330820d84ff6880652cf0b24a9e34f2f7b1808f79ada2891e5a140c4354';
const classes = {"plannedIn":"_plannedIn_paijs_1"};
const css = `._plannedIn_paijs_1 {
  margin-top: 20px;
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 20px;
  letter-spacing: 0;
  color: rgb(22, 101, 216);
  font-family: Rubik, "sans-serif";
  background: rgba(22, 101, 216, 0.1);
  width: fit-content;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  